<template>
  <div class="TreatySwitch" :data-treaty="this.$store.state.treaty" >
    <div class="TreatySwitch__treatyTitleLabel TreatySwitch__treatyTitleLabel--moratorium" v-on:click="updateTreaty('moratorium')">
      <span class="hide-sm">{{ words[this.lang].general.UniversalMoratoriumVoteLegend }}</span>
      <span class="show-sm">{{ words[this.lang].general.UniversalMoratoriumVoteLegendMobile }}</span>
    </div>
    <span class="Checkbox" v-on:click="updateTreaty()"></span>
    <div class="TreatySwitch__treatyTitleLabel TreatySwitch__treatyTitleLabel--op2" v-on:click="updateTreaty('op2')">
      <span class="hide-sm">{{ words[this.lang].general.Op2Ratification }}</span>
      <span class="show-sm">{{ words[this.lang].general.Op2RatificationLegendMobile }}</span>
    </div>
  </div>
</template>

<script>
import { words } from '@/constants/lang'

export default {
  name: 'TreatySwitch',
  data: function() {
    return {
      words,
    }
  },
  methods: {
    updateTreaty(treaty = null) {
      this.$store.commit('updateTreaty', treaty || (this.$store.state.treaty === "moratorium" ? "op2" : "moratorium"))
    }
  },
  computed: {
    lang: function () {
      return this.$store.state.language.lang
    }
  }
}
</script>

<style lang="less">

  @import "../less/_var.less";

  .TreatySwitch {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    padding: 10px 15px 8px 15px;
    box-shadow: 0 0 10px rgba(0,0,0,0.15);
    border-radius: 8px;
    background: #fff;
    width: fit-content;
    position: absolute;
    bottom: 105px;
    left: 0;
    right: 0;
    margin: 0 auto;

    .Checkbox {
      border: solid 1px #ccc;
      border-radius: 7px;
      height: 12px;
      width: 30px;
      min-width: 28px;
      position: relative;
      margin: 0px 15px;
      cursor: pointer;
      transform: scale(0.9);

      &::after {
        content: "";
        border-radius: 50%;
        height: 19px;
        width: 19px;
        box-shadow: 0 2px 5px rgba(0,0,0,0.2);
        background: @color-primary;
        position: absolute;
        transition: transform .15s ease-out;
        top: -4px;
      }
    }

    &[data-treaty="op2"] {
      .TreatySwitch__treatyTitleLabel--op2 { font-weight: 400; }
      .Checkbox {
        &::after {
          transform: translateX(17px)
        }
      }
    }

    &[data-treaty="moratorium"] {
      .TreatySwitch__treatyTitleLabel--moratorium { font-weight: 400; }
      .Checkbox {
        &::after {
          transform: translateX(-5px)
        }
      }
    }

    .TreatySwitch__treatyTitleLabel {
      font-family: @font-secondary;
      font-weight: 100;
      font-size: 0.8em;
      cursor: pointer;
      text-align: center;
    }
  }

  @media screen and (max-width: 640px) {
    .TreatySwitch {
      bottom: 160px;
    }
  }

</style>
